import React, {useEffect, useRef} from "react";

import Banner from "Components/Banner";
import Container from "Components/Container.js";
import Flex from "Components/Flex";
import useOrg from "Hooks/useOrg";

import UiBannerSeverity from "./UiBannerSeverity";


/**
 * UI banners host
 */
const UiBanners = () => {

	const {org} = useOrg();
	const containerRef = useRef(null);
	const containerStyles = {position: "sticky", top: "9rem", width: "100%", zIndex: 1000};
	const hasBanners = !!org.Banners?.length;

	useEffect(() => {
		const el = containerRef.current;
		if (!el) {
			document.documentElement.style.setProperty("--ui-banners-height", "0px");
			return () => {};
		}

		const observer = new ResizeObserver(([entry]) => {
			document.documentElement.style.setProperty(
				"--ui-banners-height",
				`${Math.round(entry.contentRect.height)}px`
			);
		});

		observer.observe(el);
		return () => {
			observer.disconnect();
			document.documentElement.style.setProperty("--ui-banners-height", "0px");
		};
	}, [hasBanners]);

	if (!hasBanners) {
		return null;
	}

	return (
		<Container rootRef={containerRef} mb={2} mt={-4} style={containerStyles}>
			<Flex gap={0}>
				{org.Banners?.map((banner, key) => (
					<Banner
						key={key}
						str={banner.Message}
						title={banner.Title}
						severity={UiBannerSeverity[banner.Severity]} />
				))
				}
			</Flex>
		</Container>
	);

};

export default UiBanners;
